import MenuIcon from '@mui/icons-material/Menu';
import { DataGrid, GridRenderCellParams, ukUA } from '@mui/x-data-grid';
import * as React from 'react';
import { ICounterparty } from '../services/interfaces';
import { dataGridSx } from './style';
import styles from './CounterpartiesTable.module.scss';

interface Props {
  data: ICounterparty[];
  onEdit: (row: ICounterparty) => void;
}

export const CounterpartiesTable: React.FC<Props> = ({ data, onEdit }) => {
  const [pageSize, setPageSize] = React.useState(16);

  return (
    <div style={{ height: 658, width: '100%', marginTop: '21px' }}>
      <DataGrid
        localeText={ukUA.components.MuiDataGrid.defaultProps.localeText}
        rows={data}
        getRowId={(row) => row.id}
        headerHeight={43}
        rowHeight={35}
        disableSelectionOnClick
        columns={[
          { field: 'id', headerName: 'ID', width: 70 },
          { field: 'gln', headerName: 'GLN', width: 120 },
          { field: 'shortName', headerName: 'Назва', minWidth: 200, flex: 0.5 },
          { field: 'fullName', headerName: 'Адреса', minWidth: 280, flex: 1 },
          {
            field: 'actions',
            headerName: 'Меню',
            headerAlign: 'center',
            width: 100,
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (params: GridRenderCellParams<ICounterparty>) => (
              <div className={styles.actionsCell}>
                <MenuIcon className={styles.icon} titleAccess="Редагувати" onClick={() => onEdit(params.row)} />
              </div>
            ),
          },
        ]}
        sx={dataGridSx}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        pagination
        disableColumnMenu
        componentsProps={{
          pagination: {
            SelectProps: {
              MenuProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    fontSize: 14,
                    bgcolor: '#ffffff',
                  },
                },
                PaperProps: {
                  sx: {
                    bgcolor: '#ffffff',
                  },
                },
              },
            },
          },
        }}
      />
    </div>
  );
};
